'use client';

import { useSiteConfig } from '@/core/components/providers/SiteConfigProvider';
import { useTranslation } from '@/core/hooks/useTranslation';

/**
 * Link to the school's Biuletyn Informacji Publicznej (simple-site §6.2.4) — Ustawienia → Dane
 * firmy → BIP. Public bodies must link their BIP from the website; shown only when it is set.
 * The mark is a simplified BIP sign; swap in the official file if a school asks for it.
 */
export function BipLink({ color }: { color?: string }) {
  const { t } = useTranslation();
  const url: string | undefined = useSiteConfig()?.bip_url;
  if (!url || !/^https?:\/\//.test(url)) return null;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm underline-offset-2 hover:underline" style={{ color }}>
      <svg viewBox="0 0 48 28" className="h-6 w-auto" aria-hidden focusable="false">
        <rect width="48" height="28" rx="3" fill="#c8102e" />
        <text x="24" y="20" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontSize="16" fontWeight="700" fill="#fff">BIP</text>
      </svg>
      <span>{t('bip.label', 'Biuletyn Informacji Publicznej')}<span className="sr-only"> ({t('a11y.new_tab', 'otwiera się w nowej karcie')})</span></span>
    </a>
  );
}
